import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useRandomId from 'hooks/useRandomId';
import ReviewStarIcon from './components/ReviewStarIcon';
import VisuallyHidden from '../VisuallyHidden';
const getStars = (rating = 0) => {
  const starValues = [];
  for (let i = 0; i < 5; i++) {
    let value;
    if (i < Math.floor(rating)) {
      value = 1;
    } else if (i === Math.floor(rating)) {
      value = parseFloat((rating - Math.floor(rating)).toFixed(1));
    } else {
      value = 0;
    }
    starValues.push({
      key: `star${i + 1}`,
      value
    });
  }
  return starValues;
};
const ReviewStars = t0 => {
  const $ = _c(38);
  const {
    errorMessage,
    rating: t1,
    noSpacing: t2,
    readOnly: t3,
    size: t4,
    onChange
  } = t0;
  const rating = t1 === undefined ? 0 : t1;
  const noSpacing = t2 === undefined ? false : t2;
  const readOnly = t3 === undefined ? false : t3;
  const size = t4 === undefined ? "lg" : t4;
  const [hoverValue, setHoverValue] = useState(null);
  let t5;
  if ($[0] !== rating) {
    t5 = getStars(rating);
    $[0] = rating;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const starValues = t5;
  let t6;
  if ($[2] !== size) {
    t6 = {
      xs: 12,
      sm: 16,
      md: 20,
      lg: 24,
      xl: 32,
      xxl: 40
    }[size] || 40;
    $[2] = size;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const iconSize = t6;
  const inputId = useRandomId();
  let t7;
  if ($[4] !== errorMessage) {
    t7 = classNames("border-solid border-2 border-transparent justify-center p-0", {
      "rounded-sm": errorMessage
    });
    $[4] = errorMessage;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== rating || $[7] !== readOnly) {
    t8 = !!readOnly && !!rating && <VisuallyHidden>Rating: {rating} out of 5 stars</VisuallyHidden>;
    $[6] = rating;
    $[7] = readOnly;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = !noSpacing;
  let t10;
  if ($[9] !== t9) {
    t10 = classNames("flex flex-row", {
      "gap-2": t9
    });
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== hoverValue || $[12] !== iconSize || $[13] !== inputId || $[14] !== onChange || $[15] !== rating || $[16] !== readOnly || $[17] !== starValues) {
    let t12;
    if ($[19] !== hoverValue || $[20] !== iconSize || $[21] !== inputId || $[22] !== onChange || $[23] !== rating || $[24] !== readOnly) {
      t12 = (starValue, index) => <label key={starValue?.key} htmlFor={`${starValue?.key}${inputId}`}><ReviewStarIcon offsetValue={starValue?.value} width={iconSize} height={iconSize} starNumber={index + 1} hoverValue={!readOnly ? hoverValue : undefined} setHoverValue={setHoverValue} rating={rating} /><input id={`${starValue?.key}${inputId}`} onChange={onChange} type="radio" name={`starInput-${inputId}`} value={index + 1} disabled={readOnly} hidden={true} /></label>;
      $[19] = hoverValue;
      $[20] = iconSize;
      $[21] = inputId;
      $[22] = onChange;
      $[23] = rating;
      $[24] = readOnly;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    t11 = starValues.map(t12);
    $[11] = hoverValue;
    $[12] = iconSize;
    $[13] = inputId;
    $[14] = onChange;
    $[15] = rating;
    $[16] = readOnly;
    $[17] = starValues;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t7 || $[31] !== t8) {
    t13 = <div className={t7}>{t8}{t12}</div>;
    $[29] = t12;
    $[30] = t7;
    $[31] = t8;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== errorMessage) {
    t14 = errorMessage && <span className="text-xs text-red">{errorMessage}</span>;
    $[33] = errorMessage;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t13 || $[36] !== t14) {
    t15 = <div className="flex flex-col justify-center relative">{t13}{t14}</div>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
};
ReviewStars.propTypes = {
  errorMessage: PropTypes.string,
  rating: PropTypes.number,
  readOnly: PropTypes.bool,
  noSpacing: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  onChange: PropTypes.func
};
export default ReviewStars;